import React from 'react'
import PropTypes from 'prop-types'

import VideoPlayer from 'agency/digital_renderer/components/VideoPlayer'
import styles from './styles.scss'

const Welcome = (props) => {
  const {
    campaignProposal,
    campaignProposal: { cover_letter, options },
  } = props

  const hasVideo = options && options.video_provider && options.video_id

  return (
    <div className={styles.root}>
      {hasVideo && <div className={styles.video}><VideoPlayer dataSource={campaignProposal} /></div>}
      <div className={styles.body}>{cover_letter}</div>
    </div>
  )
}

Welcome.propTypes = {
  campaignProposal: PropTypes.object.isRequired,
}

export default Welcome
